'use client';

import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import { Link } from '@/components/Link';
import { clsx, doesRouteMatch } from '@/utils/helpers';

export type NavLinkProps = {
  children?: ReactNode;
  href: string;
  className?: string;
};

export function NavLink({ children, href, className }: NavLinkProps) {
  const pathname = usePathname();

  const isActive = doesRouteMatch({ signature: href, route: pathname });

  return (
    <Link
      href={href}
      className={clsx(
        'hover:text-zmyle-primary font-medium hover:no-underline',
        isActive && 'text-zmyle-primary',
        className,
      )}
    >
      {children}
    </Link>
  );
}
